import { Avatar, Box, Flex, Heading, Link, Tag, Text } from '@chakra-ui/react';
import { CSSObject } from '@emotion/react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';

interface Props {
  id: string;
  fullName: string;
  createdAt: string;
  status: string;
  todoCount?: number;
}

const activeStyles: CSSObject = {
  bg: 'white',
  boxShadow: 'lg',
};

function ClientListItem({ id, fullName, createdAt, status, todoCount = 0 }: Props) {
  return (
    <Link
      as={NavLink}
      to={id}
      _hover={{ textDecoration: 'none' }}
      sx={{ '&.active > div': activeStyles }}
    >
      <Flex
        h="82"
        p={4}
        borderBottom="1px"
        borderColor="gray.200"
        align="center"
        sx={{ 'a:hover &': activeStyles }}
      >
        <Avatar name={fullName} />
        <Box flex={1} px={3}>
          <Heading as="h5" size="sm" mb={1}>
            {fullName}
          </Heading>
          <Text fontSize="sm" color="gray.500">
            Client since {moment(createdAt).format('ll')}
          </Text>
        </Box>
        <Box textAlign="right" height="100%">
          <Text fontSize="xs" fontWeight="bold" mb={1}>
            {status}
          </Text>
          {todoCount > 0 && (
            <Tag size="sm" colorScheme="purple" borderRadius="full">
              {todoCount}
            </Tag>
          )}
        </Box>
      </Flex>
    </Link>
  );
}

export default ClientListItem;
